import { EntityAboutCard } from '../EntityAboutCard/EntityAboutCard';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Industry } from '@internal/plugin-pulse-common';

export function IndustryAboutCard() {
  const { entity } = useEntity();
  const spec = (entity?.spec as Industry) ?? {};

  const fields = {
    Description: spec.description,
  };

  return <EntityAboutCard fields={fields} />;
}
